import {
  Box,
  Divider,
  FormControlLabel,
  Grid,
  styled,
  TextField,
} from '@mui/material';

export const StyleDivider = styled(Divider)(
  ({ theme }) => `
      margin-top:8px;
        border-bottom: 1px solid ${theme.palette.brand.black};
      `,
);

export const InputContainer = styled(Box)`
  width: 474px;
  margin-top: 24px;
`;

export const ComponentContainer = styled(Box)`
  margin-top: 20px;
`;

export const ComponentSectionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ComponentGridContainer = styled(Grid)`
  margin: 5px 0;
  height: calc(55vh - 80px);
  overflow-y: scroll;
  align-content: flex-start;
`;

export const ButtonContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding-bottom: 15px;
  position: fixed;
  bottom: 5px;
  right: 20px;
  background-color: ${theme.palette.primary.lightest};
`,
);

export const CheckboxLabel = styled(FormControlLabel)`
  font-size: 16px;
  weight: 300;
  font-family: 'Roboto';
  .MuiFormControlLabel-label {
    word-break: break-word;
    white-space: normal;
  }
`;

export const InputTextField = styled(TextField)(
  ({ theme }) => `
    width: 100%;
      & input {
          background: ${theme.palette.secondary.lighter};
          height: 0.8rem;
        }
  `,
);

export const CardGridWrapper = styled(Box)`
  height: calc(55vh - 80px);
  overflow-y: auto;
`;
